import React from 'react';
import ReactDOM from 'react-dom';
import './styles/main.scss';
import App from './App';
import 'animate.css';

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById('root')
);
